import { SimNaoEnum } from 'components/form'

import { PassouFalhouEnum, PodeNaoPodeEnum } from '../../enums-consultaSeguimento'
import { hasAnySim, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta18ExemplosEnum,
  ConsultaSeguimentoPergunta18Model,
} from './model-consultaSeguimentoPergunta18'

const pergunta18ExemplosEnum = Object.values(ConsultaSeguimentoPergunta18ExemplosEnum)

export const isPergunta18ExemplosAllNao = (
  value: ConsultaSeguimentoPergunta18Model['PERGUNTA_18_EXEMPLOS']
): boolean => {
  return isAllNao(value, pergunta18ExemplosEnum)
}

export function prunePergunta18(value: ConsultaSeguimentoPergunta18Model): ConsultaSeguimentoPergunta18Model {
  const pruned: ConsultaSeguimentoPergunta18Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_18_HEADER: value.PERGUNTA_18_HEADER,
  }

  const isHeaderSim = value.PERGUNTA_18_HEADER === SimNaoEnum.SIM
  const isHeaderNao = value.PERGUNTA_18_HEADER === SimNaoEnum.NAO
  const isPodeNaoPodeNaoPode = value.PERGUNTA_18_PODE_NAO_PODE === PodeNaoPodeEnum.NAO_PODE
  const isSegueOrdemNao = value.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.NAO
  const isSegueOrdemSim = value.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.SIM
  const isSentaAMesaSim = value.PERGUNTA_18_SENTA_A_MESA === SimNaoEnum.SIM

  const shouldShowMainPath = isHeaderNao || (isHeaderSim && isPodeNaoPodeNaoPode)
  const shouldShowExemplos = isSegueOrdemSim || (isSegueOrdemNao && isSentaAMesaSim)

  if (isHeaderSim) {
    pruned.PERGUNTA_18_PODE_NAO_PODE = value.PERGUNTA_18_PODE_NAO_PODE
  }

  if (shouldShowMainPath) {
    pruned.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM = value.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM
  }

  if (shouldShowMainPath && isSegueOrdemNao) {
    pruned.PERGUNTA_18_SENTA_A_MESA = value.PERGUNTA_18_SENTA_A_MESA
  }

  if (shouldShowMainPath && shouldShowExemplos) {
    pruned.PERGUNTA_18_EXEMPLOS = value.PERGUNTA_18_EXEMPLOS
  }

  return pruned
}

export function conditionToCalculatePergunta18(values: ConsultaSeguimentoPergunta18Model): boolean {
  const isHeaderSimEPode =
    values.PERGUNTA_18_HEADER === SimNaoEnum.SIM && values.PERGUNTA_18_PODE_NAO_PODE === PodeNaoPodeEnum.PODE

  if (isHeaderSimEPode) {
    return true
  }

  const isHeaderNaoOuHeaderSimENaoPode =
    values.PERGUNTA_18_HEADER === SimNaoEnum.NAO ||
    (values.PERGUNTA_18_HEADER === SimNaoEnum.SIM && values.PERGUNTA_18_PODE_NAO_PODE === PodeNaoPodeEnum.NAO_PODE)

  if (!isHeaderNaoOuHeaderSimENaoPode) {
    return false
  }

  const isSegueOrdemNaoESentaMesaNao =
    values.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.NAO && values.PERGUNTA_18_SENTA_A_MESA === SimNaoEnum.NAO

  if (isSegueOrdemNaoESentaMesaNao) {
    return true
  }

  const isSegueOrdemSimOuSegueOrdemNaoESentaMesaSim =
    values.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.SIM ||
    (values.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.NAO && values.PERGUNTA_18_SENTA_A_MESA === SimNaoEnum.SIM)

  if (isSegueOrdemSimOuSegueOrdemNaoESentaMesaSim) {
    return hasAnySim(values.PERGUNTA_18_EXEMPLOS) || isPergunta18ExemplosAllNao(values.PERGUNTA_18_EXEMPLOS)
  }

  return false
}

export function calculateResultadoPergunta18(values: ConsultaSeguimentoPergunta18Model): PassouFalhouEnum | undefined {
  if (values.PERGUNTA_18_HEADER === SimNaoEnum.SIM && values.PERGUNTA_18_PODE_NAO_PODE === PodeNaoPodeEnum.PODE)
    return PassouFalhouEnum.PASSOU

  if (
    ((values.PERGUNTA_18_HEADER === SimNaoEnum.SIM && values.PERGUNTA_18_PODE_NAO_PODE === PodeNaoPodeEnum.NAO_PODE) ||
      values.PERGUNTA_18_HEADER === SimNaoEnum.NAO) &&
    values.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.NAO &&
    values.PERGUNTA_18_SENTA_A_MESA === SimNaoEnum.NAO
  )
    return PassouFalhouEnum.FALHOU

  if (
    values.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.SIM ||
    values.PERGUNTA_18_SENTA_A_MESA === SimNaoEnum.SIM
  ) {
    if (hasAnySim(values.PERGUNTA_18_EXEMPLOS)) {
      return PassouFalhouEnum.PASSOU
    } else if (isPergunta18ExemplosAllNao(values.PERGUNTA_18_EXEMPLOS)) {
      return PassouFalhouEnum.FALHOU
    }
  }
}
